module.exports = __webpack_public_path__ + "static/media/24.b0e8776e.jpeg";